import * as MUTATIONS from '../../../state/mutations/User';
import * as React from 'react';

import * as storage from '../../../utils/storage';
import Button from '../../../components/Button/Button';
import Loading from '../../../components/Loading/Loading';
import Show from '../../../components/Show/Show';
import {
  AppState,
  Keyboard,
  KeyboardAvoidingView,
  Modal,
  ScrollView,
  StyleSheet,
  TouchableOpacity,
  TouchableWithoutFeedback,
  View,
} from 'react-native';
import { BasicModal } from '../../../components/Modal/BasicModal';
import { BasicModalWithTwoButtons } from '../../../components/Modal/BasicModalWithTwoButtons';
import { ERROR_COLOR, LIGHT_GRAY_FOR_TEXT } from '../../../config/designSystem/Colors';
import { Entypo } from '@expo/vector-icons';
import { LoginStackParamList } from '../../../types/navigation';
import { MARGIN_BOTTOM_BUTTON } from './_layout';
import { PADDING_HORIZONTAL_MODAL, SMALL_MARGIN_VERTICAL_FN, isIos, isWeb } from '../../../config/designSystem/Layout';
import { ParagraphMRegular, ParagraphSRegular } from '../../../config/designSystem/typography';
import { TermsAndConditions } from '../../../components/TermsAndConditions/TermsAndConditions';
import { TextInput2 } from '../../../components/TextInput/TextInput2';
import { TwoButtonsHorizontal } from '../../../components/Button/TwoButtonsHorizontal';
import { URL } from '../../../config/config';
import { addTag } from '../../../utils/onesignal/addTag';
import { addTrigger } from '../../../utils/onesignal/addTrigger';
import { anonymousRegisterStringForStore, registrationCodeStringForStore } from '../../../constants/storageKeys';
import { captureException } from '../../../utils/sentry/sentry';
import { checkPassword } from '../../../utils/others/password';
import { getLabelByPath } from '../../../utils/labelIter';
import { loadString, remove } from '../../../utils/storage';
import { logAmplitude, setProperty } from '../../../utils/analytics/analytics';
import { observer } from 'mobx-react';
import { useAvailableDimensions } from '../../../hooks/ui/useAvailableDimensions';
import { useEffect, useRef, useState } from 'react';
import { useManageRedirect } from '../../../hooks/authentification/useManageRedirect';
import { useManageToken } from '../../../hooks/authentification/useManageToken';
import { useMutation } from '@apollo/client';
import { useOneSignal } from '../../../components/Root/OneSignalContext';
import { usePreventScreenCaptureWhileFocused } from '../../../hooks/usePreventScreenCaptureWhileFocused';
import { useStores } from '../../../hooks/useStores';


type RegisterProps = LoginStackParamList['Register'];



const Register: React.FunctionComponent<RegisterProps> = observer(() => {
  const [registrationCode,setRegistrationCode] = useState<string>();


  const [loading, setLoading] = React.useState(false);
  const [showInScroll, setShowInScroll] = React.useState(false);
  const [modalInfoVisibility, setModalInfoVisibility] = React.useState(false);
  const [modalRequestVisibility, setModalRequestVisibility] = React.useState(false);
  const [modalThanksFeedbackVisibility, setModalThanksFeedbackVisibility] = React.useState(false);

  const nameInputRef = React.useRef(null);
  const companyInputRef = React.useRef(null);
  const emailInputRef = React.useRef(null);
  const passwordInputRef = React.useRef(null);
  const checkButtonRef = React.useRef(null);
  const requestCompanyInputRef = React.useRef(null);
  const requestEmailInputRef = React.useRef(null);
  const requestInfoInputRef = React.useRef(null);


  const [registerStatus, setRegisterStatus] = React.useState('unset');
  const [paddingScroll, setPaddingScroll] = React.useState(0);

  const [nameValue, onChangeTextName] = React.useState('');


  const [companyValue, onChangeTextCompany] = React.useState('');
  const [emailValue, onChangeTextEmail] = React.useState('');
  const [passwordValue, onChangeTextPassword] = React.useState('');

  const [requestCompany, onChangeRequestCompany] = React.useState('');
  const [requestEmail, onChangeRequestEmail] = React.useState('');
  const [requestComment, onChangeRequestComment] = React.useState('');

  const [errorMessage, setErrorMessage] = React.useState('');

  const [errorMessageRequestCode, setErrorMessageRequestCode] = React.useState('');
  const [errorRequestCode, setErrorRequestCode] = React.useState(false);

  const [withPrefilled, setWithPrefilled] = React.useState(false);

  const [forceHiding, setForceHiding] = useState(false);


  const rootStore = useStores();
  const language = rootStore?.language?.name?.key ? rootStore?.language?.name?.key : 'fr';
  const allLabels = rootStore?.language?.translate; // Do not delete this line (eval later)
  const labels = rootStore?.language?.translate?.MOBILE?.REGISTER;
  const { width, height } = useAvailableDimensions();

  const WIDTH_MODAL = Math.min(600, 0.9 * width);
  const [shown, setShown] = useState(false);
  const [anonymousRegistration, setAnonymousRegistration] = React.useState(false);

  const [checked, setChecked] = React.useState(false);

  const {redirect, redirectTowardsReckoning} = useManageRedirect();

  const {isInitialized} = useOneSignal();
  usePreventScreenCaptureWhileFocused();

  const manageAnonymousRegistration = async () => {
    const anonymousRegistrationFromStore = await storage.loadString(anonymousRegisterStringForStore);
    let valAnynomousRegistration = false;
    if(anonymousRegistrationFromStore == 'false') {
      valAnynomousRegistration= false;
      setAnonymousRegistration(false);
    }
    if(anonymousRegistrationFromStore == 'true') {
      setAnonymousRegistration(true);
      valAnynomousRegistration=true;
    }
    setChecked(valAnynomousRegistration);
  };



  const manageRegistrationCode = async () => {
    const registrationCodeFromStore =  await storage.loadString(registrationCodeStringForStore);
    if (registrationCodeFromStore) {
      setWithPrefilled(!!registrationCodeFromStore);
      onChangeTextCompany(registrationCodeFromStore as string);
      setRegistrationCode(registrationCodeFromStore as string);
    }
  };


  useEffect(() => {
    setShown(true);
    manageAnonymousRegistration();
    manageRegistrationCode();

  }, []);


  useEffect(() => {
    return () => {
      if(rootStore?.user?.user) {
        setWithPrefilled(false);
      }
    };
  }, [rootStore?.user?.user]);



  useEffect(() => {
    if(isInitialized) {
      if (registrationCode) {
        if (redirectTowardsReckoning) {
          addTrigger('in_register_with_company_code_and_redirect_towards_reckoning', registrationCode as string);
        } else {
          addTrigger('in_register_with_company_code', registrationCode as string);

        }
      }
    }

  }, [isInitialized, registrationCode, redirectTowardsReckoning]);

  const [registerMutation] = useMutation(
    MUTATIONS.register, {
      fetchPolicy: 'no-cache'
    }
  );

  const [anonymousRegisterMutation] = useMutation(
    MUTATIONS.REGISTER_ANONYMOUS, {
      fetchPolicy: 'no-cache'
    }
  );



  const [updateEvolutime] = useMutation(
    MUTATIONS.SET_EVOLUTIME,
    { fetchPolicy: 'no-cache' }
  );

  const [feedbackWithJson] = useMutation(
    MUTATIONS.FEEDBACK_WITH_JSON,
    { fetchPolicy: 'no-cache' }
  );

  const MARGIN_HORIZONTAL = 25;
  const WIDTH = Math.max(100, Math.min(800, width)) - 2 * MARGIN_HORIZONTAL;

  const appState = useRef(AppState.currentState);
  const [appStateVisible, setAppStateVisible] = useState(appState.current);




  useEffect(() => {
    const showListener = Keyboard.addListener('keyboardDidShow', _keyboardDidShow);
    const hideListener = Keyboard.addListener('keyboardDidHide', _keyboardDidHide);
    const subscription = AppState.addEventListener('change', nextAppState => {
      appState.current = nextAppState;
      setAppStateVisible(appState.current);
    });

    return () => {
      showListener.remove();
      hideListener.remove();
      subscription.remove();

    };
  }, []);


  useEffect(() => {
    setForceHiding(appStateVisible !== 'active');
  }, [appStateVisible]);


  React.useEffect(() => {
    setRegisterStatus('unset');
    setErrorMessage('');
  }, [nameValue, companyValue, emailValue, passwordValue]);


  React.useEffect(() => {
    if (withPrefilled) {
      handleNext('name');
    } else {
      handleNext('company');
    }
  }, [withPrefilled]);


  React.useEffect(() => {
    if (errorRequestCode) {
      if (requestCompany.length > 1) {
        if (isValidEmail(requestEmail)) {
          setErrorMessageRequestCode('');
          setErrorRequestCode(false);
        } else {
          setErrorMessageRequestCode(labels?.REQUEST_ERROR_EMAIL);
        }
      } else {
        setErrorMessageRequestCode(labels?.REQUEST_ERROR_COMPANY);
      }
    }
  }, [errorRequestCode, requestEmail, requestCompany]);


  const _keyboardDidShow = () => {
    setPaddingScroll(height * 0.45);
    setShowInScroll(true);
  };

  const _keyboardDidHide = () => {
    setPaddingScroll(0);
    setShowInScroll(false);
  };

  const manageNotif = async (): Promise<void> => {
    await updateEvolutime({
      variables: {
        active: false,
        daysOfWeek: [false, false, false, false, false, false, false],
        hour: 9,
        minute: 0
      }
    });
  };

  const cbAfterRegister = () => {
    console.log('in cb after register', 'init');
    setProperty({
      hasConnected: false
    });
    logAmplitude('Registration Succeeded');
    manageNotif();
    console.log('in cb after register');
    redirect(isWeb);
  };



  const manageToken = useManageToken(cbAfterRegister, redirectTowardsReckoning, true);



  const registerMutationWrapper = async (name: string, email: string, password: string, company?: string) => {
    let dataWrapper;

    if(!anonymousRegistration) {
      const { data } = await registerMutation({
        variables: {
          firstName: name,
          email,
          password,
          locale: language,
          recaptcha: '',
          link: `${URL}${language}/user/auth/activate-account`,
          registrationCode: company,
        }
      });
      if('register' in data) {
        dataWrapper = data['register'];
      }
    } else {
      const { data } = await anonymousRegisterMutation({
        variables: {
          firstName: name,
          email,
          password
        }
      });
      if('registerFromAnonymous' in data) {
        dataWrapper = data['registerFromAnonymous'];
      }
    }
    if (dataWrapper) {
      manageToken(dataWrapper);
    }
    const val = await loadString('activePath');
    if(val) {
      remove('activePath');
    }
  };


  const register = async (name: string, company: string, email: string, password: string): Promise<void> => {
    setRegisterStatus('pending');
    setLoading(true);
    if (name === '' || (company === '' && !anonymousRegistration) || email === '' || password === '' || !checked) {
      setRegisterStatus('notCompletedField');
    } else if (!checkPassword(password)) {
      setRegisterStatus('error');
      setErrorMessage(labels?.ERROR_FIELDS);
    } else {
      try {
        await registerMutationWrapper(name, email, password, company);

      } catch (err) {


        setRegisterStatus('error');
        if ((err as any)?.graphQLErrors[0].translationKey && (err as any)?.graphQLErrors[0]?.code === 403) {
          const val = getLabelByPath(allLabels, (err as any)?.graphQLErrors[0].translationKey);
          if(val) setErrorMessage(val);
        } else {
          setErrorMessage(allLabels.ERROR.AUTH_ERROR.SOMETHING_WRONG);
        }
        logAmplitude('Registration Failed');
      } finally {
        setLoading(false);
      }
    }
    setLoading(false);

  };

  const onPressRegister = () => {
    register(nameValue, companyValue, emailValue, passwordValue);
  };



  const handleNext = (newFocus: string) => {
    try{
      if (passwordInputRef !== null && passwordInputRef.current) {
        if (newFocus === 'password') {
          passwordInputRef.current.focus();
        } else {
          passwordInputRef.current.blur();
        }
      }
      if (companyInputRef !== null && companyInputRef.current) {
        if (newFocus === 'company') {
          companyInputRef.current.focus();
        } else {
          companyInputRef.current.blur();
        }
      }

      if (nameInputRef !== null && nameInputRef.current) {
        if (newFocus === 'name') {
          nameInputRef.current.focus();
        } else {
          nameInputRef.current.blur();
        }
      }
      if (emailInputRef !== null && emailInputRef.current) {
        if (newFocus === 'email') {
          emailInputRef.current.focus();
        } else {
          emailInputRef.current.blur();
        }
      }

      if (requestCompanyInputRef && requestCompanyInputRef.current) {
        if (newFocus === 'requestCompany') {
          requestCompanyInputRef.current.focus();
        } else {
          requestCompanyInputRef.current.blur();
        }
      }

      if (requestEmailInputRef && requestEmailInputRef.current) {
        if (newFocus === 'requestEmail') {
          requestEmailInputRef.current.focus();
        } else {
          requestEmailInputRef.current.blur();
        }
      }
      if (requestInfoInputRef && requestInfoInputRef.current) {
        if (newFocus === 'requestComment') {
          requestInfoInputRef.current.focus();
        } else {
          requestInfoInputRef.current.blur();
        }
      }
    } catch (err) {
      captureException(err);
    }
  };




  const EndOfRegister = () => (
    <View style={{ alignItems: 'center', justifyContent: 'center' }}>
      {registerStatus === 'error' && (
        <ParagraphSRegular color={ERROR_COLOR}>
          {errorMessage !== ''
            ? errorMessage
            : labels.ERROR_MESSAGE
              ? labels.ERROR_MESSAGE
              : 'Could not register. Please try again'}
        </ParagraphSRegular>

      )}
      {registerStatus === 'notCompletedField' && (
        <View style={{marginTop:10, marginHorizontal:25}}>
          <ParagraphSRegular color={ERROR_COLOR} align={true}>
            {errorMessage !== ''
              ? errorMessage
              : labels.ERROR_COMPLETE_FIELDS_TERMS
                ? labels.ERROR_COMPLETE_FIELDS_TERMS
                : 'Please complete the fields above or agree to the terms'}
          </ParagraphSRegular>
        </View>

      )}

      <Show when={!anonymousRegistration} >
        <TermsAndConditions accepted={checked} setAccepted={setChecked} />
      </Show>
      <Button onPress={onPressRegister} label={labels?.CREATE_BUTTON?labels.CREATE_BUTTON:'Creer mon compte'}
        marginBottom={0}
        marginHorizontal={MARGIN_HORIZONTAL} width={WIDTH}/>

    </View>
  );

  const renderCompanyIcon = () => {
    return (
      <TouchableOpacity onPress={() => {
        setModalInfoVisibility(true);
      }}>
        <Entypo name='info-with-circle' size={24} color={LIGHT_GRAY_FOR_TEXT} />
      </TouchableOpacity>
    );
  };



  const modalInfo = () => {
    return (
      <Modal animationType='fade' transparent={true} visible={modalInfoVisibility}   >
        <View style={styles.centeredView}>
          <BasicModalWithTwoButtons
            mainText={labels?.EXPLANATION_ENTREPRISE_CODE}
            onDismiss={() => {setModalInfoVisibility(false);}}
            buttonMainActionText={labels?.REQUEST_ENTREPRISE_CODE}
            onMainAction={() => {

              setModalRequestVisibility(true);
              handleNext('requestCompany');
              setModalInfoVisibility(false);

            }}
            buttonDismissText={labels?.CANCEL_ENTREPRISE_CODE}
            titleText='Information'
          />
        </View>
      </Modal>);
  };

  const modalRequestCodeWrapper = () => {
    return (
      <Modal animationType='fade' transparent={true} visible={modalRequestVisibility}>
        {isIos ? (
          <KeyboardAvoidingView
            behavior={'padding'}
            style={[styles.centeredView]}
          >
            {modalRequestCode()}

          </KeyboardAvoidingView>) : (
          <View

            style={[styles.centeredView]}
          >
            {modalRequestCode()}
          </View>

        )
        }
      </Modal>);
  };


  const isValidEmail = (email: string) => {
    const regexEmail = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
    return regexEmail.test(email);
  };

  const checkCanSendFeedback = () => {
    if (requestCompany.length <= 1) {
      setErrorRequestCode(true);
      setErrorMessageRequestCode(labels?.REQUEST_ERROR_COMPANY);
    } else if (!isValidEmail(requestEmail)) {
      setErrorRequestCode(true);
      setErrorMessageRequestCode(labels?.REQUEST_ERROR_EMAIL);
    } else {
      setModalRequestVisibility(false);
      feedbackWithJson({
        variables:
        {
          feedback:
            JSON.stringify({
              'From': 'Request-Code',
              'Company': requestCompany,
              'Email': requestEmail,
              'Comment': requestComment
            })
        }
      });

      setModalThanksFeedbackVisibility(true);
    }
  };



  const modalRequestCode = () => {
    const WIDTH_BUTTON = WIDTH_MODAL - 2 * PADDING_HORIZONTAL_MODAL - 20;

    return (
      <View style={[{ width: WIDTH_MODAL,
        backgroundColor: 'white',
        borderRadius: 10,
        paddingTop: 30,
        paddingHorizontal: PADDING_HORIZONTAL_MODAL,
        paddingBottom: 10,
        justifyContent: 'center'
      }]}>

        <ScrollView

          keyboardShouldPersistTaps='handled'
        >
          <View>
            <ParagraphMRegular>{labels?.EXPLANATION_REQUEST_FORM}
            </ParagraphMRegular>
          </View>
          <View style={{ alignItems: 'center', justifyContent: 'center', marginLeft:10, marginBottom:20  }}>
            <TextInput2
              label={labels?.REQUEST_COMPANY_PLACEHOLDER}
              value={requestCompany}
              returnKeyType='next'
              secured={false}
              image='key'
              reference={requestCompanyInputRef}
              onChangeText={(text: any) => onChangeRequestCompany(text)}
              onSubmitEditing={() => handleNext('requestEmail')}
              textContentType='none'
              marginTop={SMALL_MARGIN_VERTICAL_FN(height)}
              widthInput={WIDTH_BUTTON}
              marginHorizontal={0}
              autoFocus
            />
            <TextInput2
              label={labels?.REQUEST_EMAIL_PLACEHOLDER}
              value={requestEmail}
              returnKeyType='next'
              secured={false}
              image='envelope'
              reference={requestEmailInputRef}
              onChangeText={(text: any) => onChangeRequestEmail(text)}
              onSubmitEditing={() => handleNext('requestComment')}
              textContentType='emailAddress'
              marginTop={SMALL_MARGIN_VERTICAL_FN(height)}
              widthInput={WIDTH_BUTTON}
              marginHorizontal={0}
            />
            <TextInput2
              label={labels?.REQUEST_COMMENT_PLACEHOLDER}
              value={requestComment}
              textContentType="none"
              returnKeyType="done"
              image='comment'
              secured={false}
              reference={requestInfoInputRef}
              onChangeText={(text: string) => onChangeRequestComment(text)}
              marginTop={SMALL_MARGIN_VERTICAL_FN(height)}
              widthInput={WIDTH_BUTTON}
              marginHorizontal={0}
            />
          </View>
          {errorRequestCode ? (<View style={{
            marginHorizontal: MARGIN_HORIZONTAL,
            width: WIDTH_BUTTON,
            marginVertical: 5
          }}>
            <ParagraphSRegular color={ERROR_COLOR}>
              {errorMessageRequestCode}
            </ParagraphSRegular>
          </View>) : ''}
          <TwoButtonsHorizontal
            onPressRight={checkCanSendFeedback}
            onPressLeft={() => {
              setModalRequestVisibility(false);

            }}
            labelRight={labels?.SEND_REQUEST}
            labelLeft={labels?.CANCEL_REQUEST}
            smallText={true}
            width={WIDTH_MODAL}
          />

        </ScrollView>
      </View>);
  };

  const FieldsToDisplay = () => {
    return (<View style={[{ alignItems: 'center', justifyContent: 'center' }]}>
      {!withPrefilled &&
        <TextInput2
          label={labels?.COMPANY_PLACEHOLDER}
          value={companyValue}
          returnKeyType='next'
          secured={false}
          image='key'
          reference={companyInputRef}
          onChangeText={(text: any) => onChangeTextCompany(text)}
          onSubmitEditing={() => handleNext('name')}
          textContentType='none'
          marginBottom={30}
          autoFocus={!withPrefilled}
          keyboardType='number-pad'
          rightIcon={renderCompanyIcon}
        />
      }
      <TextInput2
        label={labels?.NAME_PLACEHOLDER}
        value={nameValue}
        returnKeyType='next'
        secured={false}
        image='user'
        reference={nameInputRef}
        onChangeText={(text: any) => onChangeTextName(text)}
        onSubmitEditing={() => handleNext('email')}
        onBlur={() => {
          if(isInitialized) {
            addTag('name', nameValue);
          }
        }}
        marginTop={0}
        textContentType='name'
        autoFocus={withPrefilled}
      />
      <TextInput2
        label={labels?.EMAIL_PLACEHOLDER}
        value={emailValue}
        returnKeyType='next'
        secured={false}
        image='envelope'
        reference={emailInputRef}
        onChangeText={(text: any) => onChangeTextEmail(text)}
        onSubmitEditing={() => handleNext('password')}
        marginTop={30}
        textContentType='emailAddress'
        importantForAutofill='yes'
      />

      <TextInput2
        label={labels?.PASSWORD_PLACEHOLDER}
        value={passwordValue}
        returnKeyType={(checkButtonRef !== null && checkButtonRef.current)?'next':'done'}
        secured={true}
        image='lock'
        reference={passwordInputRef}
        onChangeText={(text: any) => onChangeTextPassword(text)}
        onSubmitEditing={() => {
          try{
            if(checkButtonRef !== null && checkButtonRef.current) {
              checkButtonRef && checkButtonRef.current.focus();
            } else {
              onPressRegister();
            }
          } catch(error) {
            captureException(error);
          }
        }}
        marginTop={30}
        textContentType='newPassword'
        autoComplete='password-new'
        forceHiding={forceHiding}
        importantForAutofill='yes'

      />



      <View style={{
        marginHorizontal: MARGIN_HORIZONTAL,
        width: WIDTH,
        marginBottom:20,
        marginTop: 5,
      }}>

        <ParagraphSRegular color={LIGHT_GRAY_FOR_TEXT}>
          {labels.ERROR_FIELDS
            ? labels.ERROR_FIELDS
            : 'At least 5 characters, 1 lower case letter, 1 upper case letter and a number.'}
        </ParagraphSRegular>
      </View>
    </View>);
  };

  if (loading) {
    return (
      <View style={[{ flex:1}, isWeb && {marginTop: 200}]}>
        <Loading withLabel={false} />
      </View>

    );
  }

  const mainPart = () => {
    return(
      <>{modalInfo()}
        {modalRequestCodeWrapper()}
        {<BasicModal isVisible={modalThanksFeedbackVisibility} onDismiss={() => setModalThanksFeedbackVisibility(false)} mainText={labels?.FEEDBACK_THANKS_MAIN_TEXT} buttonText={labels?.FEEDBACK_THANKS_BUTTON} />}
        <View style={{ flex: 1, backgroundColor: '#fff', marginBottom: MARGIN_BOTTOM_BUTTON }}>

          {isWeb ? (<><ScrollView  >
            {FieldsToDisplay()}
            <EndOfRegister />
          </ScrollView>
          </>) : (
            <>
              <View style={{ flex: 1 }}>
                <TouchableWithoutFeedback
                  onPress={() => Keyboard.dismiss()}>
                  <ScrollView showsVerticalScrollIndicator={false} accessible={false}
                    keyboardShouldPersistTaps='handled' contentContainerStyle={{ paddingBottom: paddingScroll }} >
                    {shown && FieldsToDisplay()}
                    {showInScroll && <EndOfRegister />}
                  </ScrollView>

                </TouchableWithoutFeedback>
              </View>
              {!showInScroll &&
            <EndOfRegister />}
            </>)}
        </View >
      </>);
  };

  return (<>
    {isWeb?(
      <View style={{width, height, backgroundColor: 'white'}}>
        {mainPart()}

      </View>) : (<>{mainPart()}</>)
    }
  </>
  );
});
const styles = StyleSheet.create({
  transparent: {
    backgroundColor: 'rgba(0,0,0,0.6)',
  },
  centeredView: {
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'rgba(0,0,0,0.6)',
    flex: 1
  },
  openButton: {
    borderRadius: 20,
    padding: 10,
    marginHorizontal: 15,
    marginTop: 10,
    elevation: 2,
  },
  textStyle: {
    color: 'white',
    fontWeight: 'bold',
    textAlign: 'center',
  },
  modalText: {
    marginBottom: 15,

    textAlign: 'center',
  }
});

export default Register;
